import { BdsButtonIcon, BdsGrid, BdsInput } from 'blip-ds/dist/blip-ds-react/components';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { DocumentRow as DocumentRowProps } from '../../interfaces';
import './DocumentRow.scss';

export const DocumentRow = ({
  data,
  position,
  handleChangeData,
  handleDelete,
  onErrorChange,
  isUnique,
  isDuplicated,
}: DocumentRowProps) => {
  const { t } = useTranslation();
  const isNameRequired = data.document.trim() !== '';
  const isDocumentRequired = data.name.trim() !== '';

  const showNameError = isNameRequired && data.name.trim() === '';
  const showDocumentError = isDocumentRequired && data.document.trim() === '';

  const hasError = showNameError || showDocumentError || isDuplicated;

  useEffect(() => {
    onErrorChange(position, hasError);
  }, [hasError, position]);

  return (
    <BdsGrid gap="2" alignItems="flex-start" padding="none" class="document_row">
      <BdsInput
        danger={isDuplicated || (hasError && !data.name)}
        label={t('go-personal-document-row-title-label')}
        data-testid="document-name"
        class="document_name"
        counterLength
        maxlength={30}
        rows={1}
        value={data.name}
        onBdsInput={ev => handleChangeData({ field: 'name', position: position, value: ev.target.value ?? '' })}
        errorMessage={
          isDuplicated ? t('go-personal-document-row-error-duplicate') : t('go-personal-document-row-error-empty')
        }
      />
      <BdsGrid gap="2" alignItems="flex-start" padding="none" class="document_reply">
        <BdsInput
          danger={hasError && !data.document}
          label={t('go-personal-document-row-reply-label')}
          isTextarea
          rows={3}
          placeholder={t('go-personal-document-row-reply-placeholder')}
          value={data.document}
          data-testid="document-input"
          onBdsInput={ev => handleChangeData({ field: 'document', position: position, value: ev.target.value ?? '' })}
          errorMessage={t('go-personal-document-row-error-empty')}
        />
        <BdsButtonIcon
          size="short"
          variant="secondary"
          icon="trash"
          onClick={() => handleDelete(data)}
          data-testid="delete-button"
          disabled={isUnique}
        />
      </BdsGrid>
    </BdsGrid>
  );
};
